



































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Database, Query, StoredAnswer} from '@/database';
import Table from './Table.vue';
import Puzzle from './Puzzle.vue';

@Component({
    components: {
        Table,
        Puzzle,
    },
})
export default class Example extends Puzzle {
}
